// frontend/src/services/api/modules/agenda.js
import { API_URL } from '../config';
import { getAuthHeaders, fetchWrapper } from '../utils/fetchWrapper';

/**
 * GET /api/agenda - Unified agenda (objects + personal + Google Calendar)
 */
export const obtenerAgenda = async () => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetchWrapper(`${API_URL}/api/agenda`, { headers });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      return { error: err.error || 'Error al obtener agenda' };
    }
    return await response.json();
  } catch (error) {
    console.error('Error en obtenerAgenda:', error);
    return { error: 'Error de conexión' };
  }
};

/**
 * GET /api/agenda/count - Count for badge
 */
export const obtenerAgendaCount = async () => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetchWrapper(`${API_URL}/api/agenda/count`, { headers });
    if (!response.ok) return { count: 0 };
    return await response.json();
  } catch (error) {
    console.error('Error en obtenerAgendaCount:', error);
    return { count: 0 };
  }
};

/**
 * POST /api/recordatorios-personales - Create user-level personal reminder
 */
export const crearRecordatorioPersonal = async (data) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetchWrapper(`${API_URL}/api/recordatorios-personales`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      return { error: err.error || 'Error al crear recordatorio' };
    }
    return await response.json();
  } catch (error) {
    console.error('Error en crearRecordatorioPersonal:', error);
    return { error: 'Error de conexión' };
  }
};

/**
 * PUT /api/recordatorios-personales/:id - Update
 */
export const actualizarRecordatorioPersonal = async (id, data) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetchWrapper(`${API_URL}/api/recordatorios-personales/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      return { error: err.error || 'Error al actualizar recordatorio' };
    }
    return await response.json();
  } catch (error) {
    console.error('Error en actualizarRecordatorioPersonal:', error);
    return { error: 'Error de conexión' };
  }
};

/**
 * DELETE /api/recordatorios-personales/:id - Delete
 */
export const eliminarRecordatorioPersonal = async (id) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetchWrapper(`${API_URL}/api/recordatorios-personales/${id}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      return { error: err.error || 'Error al eliminar recordatorio' };
    }
    return await response.json();
  } catch (error) {
    console.error('Error en eliminarRecordatorioPersonal:', error);
    return { error: 'Error de conexión' };
  }
};

/**
 * POST /api/ai/extract-reminder - Analyze image with AI to extract reminder data
 */
export const analizarImagenConIA = async (imageBase64) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetchWrapper(`${API_URL}/api/ai/extract-reminder`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        image: imageBase64,
        context: 'Extrayendo datos para recordatorio personal',
      }),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      if (response.status === 429) {
        return { error: 'Demasiadas solicitudes de análisis. Espera 15 minutos.' };
      }
      return { error: err.error || 'Error al analizar imagen' };
    }
    return await response.json();
  } catch (error) {
    console.error('Error en analizarImagenConIA:', error);
    return { error: 'Error de conexión' };
  }
};
